import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IFunctionCourseOfActions, IFunctionGoals } from '../models/functionGoal';
import { ErrorService } from '../helpers/errorService';
import { IThreat } from '../models/threat';

@Injectable({
    providedIn: 'root'
})
export class FunctionService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getFunctions(buildingId: string): Observable<{has_error: boolean, message: string, data: IFunctionGoals[]}> {
        const url = environment.apiBaseUrl + endpoints.functions.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IFunctionGoals[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getAllFunctionalAssignments(buildingId: string): Observable<{has_error: boolean, message: string, data: IFunctionGoals[]}> {
        const url = environment.apiBaseUrl + endpoints.getAllFunctionalAssignments.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IFunctionGoals[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createNewThreat(buildingId: string, functionData: IFunctionGoals): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createNewFunction.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, functionData).pipe(
            catchError(this.errorService.handleError)
        );
    }

    editFunction(functionData: any, functionId: number): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.editFunction.replace(':functionId', functionId + '');
        return this.http.put<{has_error: boolean, message: string, data: any}>(url, functionData).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteFunction(functionId: number): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteFunction.replace(':functionId', functionId + '');
        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
    
    saveFunctionalAssignment(buildingId: string, threatId:string, functionsData: number[]): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createFunctionalAssignment.replace(':buildingId', buildingId).replace(':threatId', threatId);;
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, functionsData).pipe(
        catchError(this.errorService.handleError)
        );
    }
}